import 'moment/locale/pt-br'

import moment from 'moment'

const momentBR = (inp?: moment.MomentInput, strict?: boolean) =>
  moment(inp, strict).locale('pt-br')

export default momentBR
